export enum OCI {
  START = 'I',
  SEARCH = 'confirmationInput'
}
